module.exports = __webpack_public_path__ + "img/dress11.fa8b9051.jpeg";